export default __webpack_public_path__ + "content/20653d2fac6285bf4deac9919fcb434d.ttf";